import type { SpecificVendor as SpecificVendorType } from '../../../../../../api/types/rater-x-preset';
import type { SVFormValues } from '../../../../../../../../primeX-underwriter/modals/coverageLineItemModals/SpecificVendorEndorsementModal';
import SpecificVendorEndorsementModal from '../../../../../../../../primeX-underwriter/modals/coverageLineItemModals/SpecificVendorEndorsementModal';
import {
  formatVendorsForState,
  getDefaultVendorValues,
} from '../../amendatory-coverages/line-items/SpecificVendorEndorsement';
import type { RaterXModalProps } from './types';

const RaterXSpecificVendorEndorsementModal = ({
  data,
  close,
}: RaterXModalProps) => {
  const onSubmit = (formValues: SVFormValues) => {
    const _vendors = formatVendorsForState(formValues);

    data.setCoverage({
      id: data.coverageState.id,
      isSelected: true,
      value: {
        props: {
          items: { values: _vendors as unknown as SpecificVendorType[] },
        },
      },
    });
  };

  return (
    <SpecificVendorEndorsementModal
      close={close}
      data={{
        onSubmit,
        vendors: getDefaultVendorValues(
          data.coverageState.value?.props?.items?.values as SpecificVendorType[]
        ),
        language: data.language,
      }}
    />
  );
};

export default RaterXSpecificVendorEndorsementModal;

export const RaterXSpecificVendorEndorsementModalConfig = {
  RaterXSpecificVendorEndorsementModal: {
    component: RaterXSpecificVendorEndorsementModal,
    config: {
      title: 'Specific Vendor Endorsement',
      fullWidth: true,
      maxWidth: 'md',
    },
  },
};
